import React, { Fragment, useState, useEffect } from "react";
import { Card, Form, Spinner } from "react-bootstrap";
import {  useLocation, useParams, Link } from "react-router-dom";
import Snackbars from "../../../utils/Snackbars";
import useRequests from "../../../utils/useRequests";
import DataTable from "react-data-table-component";


const UserPurchasedTickets = () => {
  const { u_id } = useParams();
  const location = useLocation();
  const { getRequest } = useRequests();

  const [usersTickets, setUsersTickets] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

 

  const [AlertData, setAlertData] = React.useState({
    variant: '',
    message: '',
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: '',
        message: '',
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState("");

  const fetchPurchaseTickets = async () => {
    const response = await getRequest(`user-purchase-tickets/${u_id}`); // Replace "users" with the appropriate API endpoint
    if (response && response.code === 200) {
      setUsersTickets(response.data);
    } else {
      console.error("Failed to fetch users tickets:", response.message);
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: response.message,
      }));
    }
    resetAlertData();
    setLoading(false);
  };

  const fetchUserData = async () => {
    try {
        const response = await getRequest(`/user/${u_id}`);
        console.log("Fetched user data:", response); // Debug log
        setUserName(response.data[0].first_name? response.data[0].first_name+" "+response.data[0].last_name: response.data[0].phone)

        if (response && Array.isArray(response.data) && response.data.length > 0) {
            // Access the first element of the data array
            const { first_name = "", last_name = "", email = "", phone = "" } = response.data[0];
        } else {
            console.error("No user data found in the response.");
        }
        setLoading(false);
    } catch (error) {
        console.error("Error fetching user data:", error);
        setLoading(false);
    }
};

  useEffect(() => {
    fetchPurchaseTickets();
    fetchUserData();
    if (location.state && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
      setLoading(false);
    }
  }, []);

  // Filter users based on the search query
  const filteredUsers = usersTickets.filter((tickets) => {
    const event = `${tickets.name}`.toLowerCase();

    const duration = `${tickets.duration} day`;

    const quantity = `${tickets.quantity}`;

    const type = `${tickets.type}`.toLowerCase();
    const purchase_price = `${tickets.purchase_price}`.toLowerCase();

    const date = new Date(tickets.purchase_date);
    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const purchase_date = `${formattedDate}`;

    const payment_id = `${tickets.payment_id}`.toLowerCase();

    // const query = {fullName, email};
    // return query.includes(searchQuery.toLowerCase());
    const searchLower = searchQuery.toLowerCase();
  
    return quantity.includes(searchQuery) || event.includes(searchLower) || duration.includes(searchLower) || type.includes(searchLower) || purchase_price.includes(searchQuery)|| purchase_date.includes(searchQuery)|| payment_id.includes(searchQuery);
  });




  const columns = [
    {
      name: "Event",
      selector: (row) => `${row.name}`,
      sortable: true,
    },
    {
      name: "Duration",
      selector: (row) => `${row.duration} day`,
      sortable: true,
      width: "200px" 
  },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "No. of Tickets",
      selector: (row) => `${row.quantity}`,
      sortable: true,
      width: "150px" 
    },
    {
      name: "Purchase Price",
      selector: (row) => row.purchase_price,
      sortable: true,
    },
    {
      name: "Purchase Date",
      selector: (row) => {
        const date = new Date(row.purchase_date);
        const formattedDate = date.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${formattedDate}`;
      },
      sortable: true,
    },
    {
      name: "Payment Id",
      selector: (row) => row.payment_id,
      sortable: true,
    },
    
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headCells: {
      style: {
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
      },
    },
    pagination: {
      style: {
        fontSize: "16px",
      },
    },
  };

  // if (loading) return <p>Fetching data...</p>;

  return (
    <Fragment>
      <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <h2 className='text-black font-w600 mb-0'>{userName} Purchase Tickets</h2>
        <Link to="/user-list" type="button" className="btn btn-rounded btn-primary">
          Back to User
        </Link>
      </div>

      {/* Search input */}
      <div className='mb-4 d-sm-flex d-block justify-content-end'>
      <div style={{ position: "relative", width: "18rem" }}>
  <Form.Control
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    style={{
      width: "100%",
      fontSize: "18px",
      fontWeight: 500,
      paddingRight: "2rem",
      borderRadius:'0.625rem',
      height:'3.2rem' // Add padding to ensure the icon doesn't overlap text
    }}
  />
  <i
    className="fa fa-search"
    style={{
      position: "absolute",
      right: "10px", // Distance from the right edge of the input
      top: "50%",
      transform: "translateY(-50%)", // Center vertically
      color: "#6c757d", // Optional: color for the icon
      pointerEvents: "none", // Makes sure clicks pass through to the input
    }}
  ></i>
</div>
      </div>

      <Card>
        <Card.Body>
          {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' />
                  <p>Loading settings...</p>
                </div>) : 
          (<DataTable
            columns={columns}
            data={filteredUsers} // Use filtered data
            customStyles={customStyles}
            pagination
            highlightOnHover
            responsive
          />)}
        </Card.Body>
      </Card>

    </Fragment>
  );
};

export default UserPurchasedTickets;
